export async function getAllCandidates(token) {
    const url = `api/hr/candidates`;

    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch All candidates: ${response.status}`);
    }
    return await response.json();
}

export async function getCandidatesByCompanyId(token) {
    const url = `api/hr/candidates-by-company`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to get candidates: ${response.status}`);
    }
    return await response.json();
}

export async function getAllJobs(token) {
    const url = `api/hr/active/jobs`;

    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch All Jobs: ${response.status}`);
    }
    return await response.json();
}

export async function getJobsByCompanyId(token){
    const url = `api/hr/jobs-by-company`;

    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch Jobs: ${response.status}`);
    }
    return await response.json();
}

export async function getJobsExternal(clientId) {
    const url = `api/public/jobsExternal/${clientId}`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch job title`)
    }
    return await response.json();
}

export async function getOpportunities(clientId) {
    const url = `api/public/opportunities/${clientId}`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch opportunities`)
    }

    return await response.json();
}

export async function getSelectedJobsByCompanyId(companyId, token){
    const url = `api/hr/jobs/${companyId}`;

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to fetch jobs: ${response.status}`);
    }
    return await response.json();
}


export async function getSelectedCandidatesByCompanyId(companyId, token){
    const url = `api/hr/candidates/company/${companyId}`;

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to fetch candidates: ${response.status}`);
    }
    return await response.json();
}

export async function getCandidatesByJobId(jobId, token){
    const url = `api/hr/candidates/${jobId}`;

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to fetch candidates: ${response.status}`);
    }
    return await response.json();
}

export async function postJob(job, token){
    const url = `api/hr/jobs`;

    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(job),
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to post job: ${response.status}`);
    }
}

export async function postJobByClient(job, companyId, token){
    const url = `api/hr/add-jobs-by-client-id/${companyId}`;

    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(job),
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to post job: ${response.status}`);
    }
}

export async function putJob(id, job, token){
    const url = `api/hr/jobs/${encodeURIComponent((id))}`;

    const response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(job),
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to put job: ${response.status}`);
    }
}

export async function editJobByClient(job, companyId, token){
    const url = `api/hr/edit-jobs-by/${companyId}`;

    const response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(job),
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to put job: ${response.status}`);
    }
}

export async function deleteJob(id, token){
    const url = `api/hr/jobs/${encodeURIComponent((id))}`;

    const response = await fetch(url, {
        method: "DELETE",
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to delete job: ${response.status}`);
    }
}

export async function postNotes(notes, token){
    const url = `api/hr/notes`;

    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(notes),
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to post notes: ${response.status}`);
    }
}

export async function deleteNotes(id, token){
    const url = `api/hr/notes/${encodeURIComponent((id))}`;

    const response = await fetch(url, {
        method: "DELETE",
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to delete note: ${response.status}`);
    }
}

export async function findNotesByCandidateId(id, token){
    const url = `api/hr/notes/${id}`;

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if(!response){
        throw new Error(`Failed to fetch notes: ${response.status}`);
    }
    return await response.json();
}

export async function editNotes(id, notes, token){
    const url = `api/hr/notes/${encodeURIComponent((id))}`;

    const response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(notes),
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to post notes: ${response.status}`);
    }
}

export async function findCandidateById(id, token){
    const url = `api/hr/candidate/${encodeURIComponent((id))}`;

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to fetch candidate with ID ${id}: ${response.status}`);
    }
    return await response.json();
}

export async function updateCandidateState(cvId, candidate, token){
    const url = `api/hr/candidateState/${encodeURIComponent((cvId))}`;

    const response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(candidate),
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to update candidate state: ${response.status}`);
    }
}

export async function getEmails(candidateId, token) {
    const url = `api/hr/emails/${encodeURIComponent((candidateId))}`;

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to get emails for the candidate with ID ${candidateId} : ${response.status}`);
    }
    return await response.json();
}

export async function getCandidateDocuments(candidateId, token) {
    const url = `api/hr/documents/${encodeURIComponent((candidateId))}`;

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to get documents for the candidate with ID ${candidateId} : ${response.status}`);
    }
    return await response.json();
}

export async function deleteCandidateDocuments(id, token){
    const url = `api/hr/documents/${encodeURIComponent((id))}`;

    const response = await fetch(url, {
        method: "DELETE",
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to delete document: ${response.status}`);
    }
}

export async function getUsersByGroup(token) {
    const url = `api/hr/groupId/members`;

    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch users from group: ${response.status}`);
    }
    return await response.json();
}
